import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://json-expense-server.onrender.com/",
});

export default axiosInstance;
